import $ from 'jquery';
import React from 'react';
import Pagination from "react-js-pagination";
import exportIcon from '../../components/css/dark/img/theme-images/export.svg';
import moment, { relativeTimeRounding } from 'moment';

class ManageGroupPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            error: '',
            loader: true,
            activePage: 1,
            UserList: [],
            UserList_Temp: [],
            mainAPIresult: [],
            disableImage: true,
            searchBoxValue: '',
            Data_Not_Found: '',
            conditionalLoader: false,
            finalrecorddone: false,
            totalPage: 0,
            Search: '',
            Coloumshorting: 'CreatedOn',
            shortingwise: 'desc'
        };
    }
    componentDidUpdate() {
        //if (this.state.conditionalLoader) {
        //    //   this.advanceSearch();
        //    //  }
        //    this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', this.state.searchBoxValue, this.state.Coloumshorting, this.state.shortingwise);
        //}
    }
    componentDidMount() {
        //let Search;
        //Search = '';
        // $(".customGroupG").prop("checked", true);
        // $(".customOrderA").prop("checked", true);

        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);

        if (this.state.Search == null) {
            this.state.Search = '';
        }

        // this.state.Coloumshorting = "GroupNumber";
        // this.state.shortingwise = "asc";
        this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', '', this.state.Coloumshorting, this.state.shortingwise);
        $('.pagination li:first-child').text('First');
        $('.pagination li:last-child').text('Last');
    }
    fetchDataLocally(roleName, roleType, PagingIndex, Search, Coloumshorting, shortingwise) {
        try {            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ roleName, roleType, PagingIndex, Search, Coloumshorting, shortingwise })
            };
            return fetch(`/api/admin/ManageGroupNumberPagingWise`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {                        
                        if (apidata.length > 0 && parseInt(apidata[0].total) != 0)
                            this.setState({
                                totalList: apidata[0]["sp_Records"],
                                totalPage: parseInt(apidata[0].total),
                                UserList: apidata[0]["sp_Records"],
                                activePage: parseInt(PagingIndex),
                                loader: false,
                                conditionalLoader: false

                            });
                        else {
                            if (apidata.length == 0 || (apidata.length > 0 && parseInt(apidata[0].total) == 0))
                                this.setState({
                                    ...this.state, UserList: [], loader: false, Data_Not_Found: 'No records found', totalPage: 0, conditionalLoader: false
                                });
                        }

                    }
                    catch (error) {
                        $('.configure-error-content').text('Please try later');
                        $('.configure-heading').text('Error');
                        $(".configure-error").animate({ right: 0 + 'px' }, 1000);
                        this.setState({
                            ...this.state, UserList: [], Data_Not_Found: '', totalPage: 0
                        });
                    }
                });

        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    createDashboard = (e) => {
        this.setState({ disableImage: false });
        $(e.target).css("opacity", 0.5);
        let wholesalerName = $(e.target).attr('data-name');
        let wholesalerId = $(e.target).attr('data-id');
        this.newDashboard(this.state.userdata.paramsname, this.state.userdata.userrole, wholesalerName, wholesalerId);
    }
    handlePageChange = (pageNumber) => {
        try {
            // let userlistobj = JSON.parse(JSON.stringify(this.state.UserList));
            // let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice((pageNumber - 1) * 9, 9) : userlistobj;
            this.setState({ loader: true });
            let pname = this.state.userdata.paramsname;
            let rname = this.state.userdata.userrole;
            this.fetchDataLocally(pname, rname, pageNumber.toString(), this.state.searchBoxValue, this.state.Coloumshorting, this.state.shortingwise);
        }
        catch (error) { }


    }
    searchOnButtonClick = () => {
        try {
            this.setState({ conditionalLoader: true });
            this.state.Search = this.state.searchBoxValue;
            this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', this.state.searchBoxValue, this.state.Coloumshorting, this.state.shortingwise);
        } catch (error) { }
    }
    advanceSearch = (event) => {
        this.state.Search = this.state.searchBoxValue;
        let serachText = this.state.searchBoxValue;
        let userlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.wholeSeller.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)

        });
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.wholeSeller.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)

        });

        if (userlistobj.length == 0 || copyuserlistobj.length == 0) this.setState({ Data_Not_Found: 'No records found' });

        let usertemplistobj = userlistobj.length > 9 ? userlistobj.splice(0, 9) : userlistobj;
        this.setState({ activePage: 1, UserList: copyuserlistobj, UserList_Temp: usertemplistobj, conditionalLoader: false });
    }
    SearchOnKeyUp = (event) => {
        try {
            const { name, value } = event.target;
            if (event.key === 'Enter') {
                this.setState({ loader: true, searchBoxValue: this.state.searchBoxValue });
                $('.theme-loader').removeClass('search');
                $('.signInButton').removeClass('animated-btn');
                this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', this.state.searchBoxValue, this.state.Coloumshorting, this.state.shortingwise);
                event.preventDefault();
                return false;
            }
        } catch (error) { }
    }
    SearchOnKeyChange = () => {
        try {
            this.setState({ searchBoxValue: $('#SearcInput').val() });
        } catch (error) { }
    }
    sortGroupNumber = (e) => {
        if (this.state.shortingwise == 'asc') {
            try {
                this.setState({ shortingwise: 'desc', loader: true, Coloumshorting: 'GroupNumber' });
                this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', this.state.searchBoxValue, 'GroupNumber', 'desc');
            } catch (error) { }
            $(e.target).toggleClass('active');
        } else {
            try {
                this.setState({ shortingwise: 'asc', loader: true, Coloumshorting: 'GroupNumber' });
                this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', this.state.searchBoxValue, 'GroupNumber', 'asc');
            } catch (error) { }
            $(e.target).toggleClass('active');
        }
    }
    sortWholesaler = (e) => {
        if (this.state.shortingwise == 'asc') {
            try {
                this.setState({ shortingwise: 'desc', loader: true, Coloumshorting: 'WholeSeller' });
                this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', this.state.searchBoxValue, 'WholeSeller', 'desc');
            } catch (error) { }
            $(e.target).toggleClass('active');
        } else {
            try {
                this.setState({ shortingwise: 'asc', loader: true, Coloumshorting: 'WholeSeller' });
                this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', this.state.searchBoxValue, 'WholeSeller', 'asc');
            } catch (error) { }
            $(e.target).toggleClass('active');
        }
    }
    sortCreateOn = (e) => {
        if (this.state.shortingwise == 'asc') {
            try {
                this.setState({ shortingwise: 'desc', loader: true, Coloumshorting: 'CreatedOn' });
                this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', this.state.searchBoxValue, 'CreatedOn', 'desc');
            } catch (error) { }
            $(e.target).toggleClass('active');
        } else {
            try {
                this.setState({ shortingwise: 'asc', loader: true, Coloumshorting: 'CreatedOn' });
                this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, '1', this.state.searchBoxValue, 'CreatedOn', 'asc');
            } catch (error) { }
            $(e.target).toggleClass('active');
        }
    }    
    manageEmail = (e) => {
        let currentId = $(e.target).attr('data-id');
        let currentWholesaler = $(e.target).attr('data-name');
        let whId = $(e.target).attr('datawhid');
        this.props.manageEmailPopup(currentId, whId, currentWholesaler);
        this.props.closePopup();
    }
    manageProfile = (e) => {
        let currentId = $(e.target).attr('data-id');
        let currentWholesaler = $(e.target).attr('data-name');
        this.props.manageGroupPopup(currentId, currentWholesaler);
        this.props.closePopup();
    }
    ExportReps(e) {
        try {
            let Origin_Location = window.origin;
            window.open(
                Origin_Location + '/report/Export_ManageGroupNoReport',
                '_blank'
            );
            e.preventDefault();
        }
        catch (error) { }
    }
    render() {
        const { error, loader, conditionalLoader } = this.state
        let disabled = false;
        disabled = this.state.loader ? true : false;
        return (
            <div>
                <div className='popup mfp-zoom-in manage-scroll manage-distributor-design admin-group-number group-issue'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>

                        {
                            loader ? (<div className="theme-loader"></div>) : null
                        }
                        {/*                        <a href="javascript:void('0')" className="rep-download custom-tooltip"><img onClick={this.ExportReps} src={exportIcon} className="export_icon" alt="Download Icon" /><span className="hover-tooltip">Download report</span></a>*/}
                        <div className="searchSection populate">
                            <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
                                <div className="autocomplete">
                                    <input id="SearcInput" type="text" name="searchBoxValue" scroll-id="CITY" data-id="dynamic" disabled={disabled} value={this.state.searchBoxValue} placeholder="Search" onKeyDown={this.SearchOnKeyUp} onChange={this.SearchOnKeyChange} className="form-control searchTable searchtextarea" />
                                    <div className="loader-container">
                                        <button className={conditionalLoader ? "signInButton btn animated-btn" : "signInButton btn"} disabled={disabled} onClick={this.searchOnButtonClick}>Search</button>
                                        {
                                            conditionalLoader ? <div className="theme-loader search"></div> : null
                                        }
                                    </div>
                                </div>
                            </form>
                        </div>
                        { /*
                        <div className="right-side radio-button-section">
                            <div className="first-tab-section">
                                <span>Sorting Column wise</span>
                                <div className="same radio-design custom-tooltip">
                                    <input type="radio" name="customGroup" id="gNumber" value="GroupNumber" checked={this.state.Coloumshorting === "GroupNumber"} onChange={this.RadioColomChange} disabled={disabled}/>
                                    <label className="checkmark" for="gNumber">Group Number</label>
                                </div>
                                <div className="same radio-design custom-tooltip">
                                    <input type="radio" name="customGroup" id="whSaler" value="WholeSeller" checked={this.state.Coloumshorting === "WholeSeller"} onChange={this.RadioColomChange} disabled={disabled} />
                                    <label className="checkmark" for="whSaler">Wholesaler</label>
                                </div>
                            </div>
                            <div className="second-tab-section">
                                <span>Sorting Order</span>
                                <div className="same radio-design custom-tooltip">
                                    <input type="radio" id="ascending" name="customOrder" value="asc" checked={this.state.shortingwise === "asc"} onChange={this.RadioOrderChange} disabled={disabled}/>
                                    <label className="checkmark" for="ascending">Ascending</label>
                                </div>
                                <div className="same radio-design custom-tooltip">
                                    <input type="radio" id="descending" name="customOrder" value="desc" checked={this.state.shortingwise === "desc"} onChange={this.RadioOrderChange} disabled={disabled}/>
                                    <label className="checkmark" for="descending">Descending</label>
                                </div>
                            </div>
                        </div>
                        */}
                        <div className="content-section">

                            <table className="table table-striped">
                                <thead>
                                    {
                                        this.state.UserList != null && this.state.UserList.length > 0 ?
                                            <tr className="header">
                                                <th className="first-one"><span onClick={this.sortGroupNumber}>Group Number</span></th>
                                                <th className="second-one" onClick={this.sortWholesaler}><span>Wholesaler Name</span></th>
                                                <th className="third-one">Wholesaler Commission($)</th>
                                                <th className="fourth-one" onClick={this.sortCreateOn}><span>Created On</span></th>

                                            </tr> : <tr className="border-none">
                                                {
                                                    this.state.loader ?
                                                        <td className="please-wait"><h3>Please wait...</h3></td> :
                                                        <td className="please-wait color-red"><h3>{this.state.Data_Not_Found}</h3></td>
                                                }
                                            </tr>
                                    }
                                </thead>
                                {
                                    this.state.UserList != null && this.state.UserList.length > 0 ?
                                        <tbody id="inactive_reps">
                                            {
                                                this.state.UserList.map((e1, i1) => {
                                                    return (

                                                        <tr className="userDashData" key={i1}>
                                                            <td className="first-one">
                                                                {e1.groupNumber}
                                                            </td>
                                                            <td className="second-one">
                                                                {e1.wholeSeller}
                                                            </td>
                                                            <td className="third-one">
                                                                {e1.wholeSellerCommsion}
                                                            </td>
                                                            <td className="fourth-one">
                                                                {e1.createdOn}
                                                            </td>

                                                        </tr>)
                                                })
                                            }
                                        </tbody> : null
                                }
                            </table>
                            {
                                this.state.UserList != null && this.state.UserList.length > 0 ?
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={10}
                                        totalItemsCount={this.state.totalPage}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange.bind(this)}
                                    /> : null
                            }
                            {error &&
                                <div className={'alert alert-danger delete'}>{error}</div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default ManageGroupPopup;